import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { SvgIcon } from 'components/SvgIcon';
import Translate from 'components/Translate';
import ConfigCountry from 'components/Cart/ConfigCountry';
import { IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  cart: IProductData;
}

@WithStyles(() => ({
  component: {
    width: '100%',
    position: 'absolute',
    zIndex: 1,
    backgroundColor: '#FFF',
    color: '#192542',
    maxHeight: 32,
    '& .chk-wrapper': {
      height: 32,
      margin: 'auto',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: 2,
      maxWidth: 1024
    },
    '& .chk-language__logo': {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        fill: '#1E406E'
      },
      '& span': {
        fontSize: '.625rem',
        margin: '0 0 0 4px'
      }
    },
    '& .chk-language__selectLanguage': {
      alignItems: 'center',
      display: 'flex',
      fontSize: '.625rem',
      '& span': {
        padding: '0 8px 0 0'
      },
      '& .chk-config-country': {
        cursor: 'pointer',
        '& .chk-config-button': {
          border: 'none',
          padding: '0',
          '& .chk-option-active': {
            fontSize: '.625rem',
            margin: '1px 0 0 4px',
            '&:after': {
              content: '"▼"',
              color: '#999999',
              fontSize: '8px',
              margin: '0 0 0 4px'
            }
          }
        },
        img: {
          height: '11px',
          width: '17px'
        }
      }
    }
  }
}))
export default class Language extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      cart: null
    };
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  hideCurrency = (): boolean => {
    const { cart } = this.state;

    if (
      (!cart.config.enableCreditcard && !cart.config.enablePaypal && cart.config.enableBankslip) ||
      !cart.config.foreignEnabled ||
      cart.config.availableCurrencies.length === 1
    ) {
      return true;
    }

    return false;
  };

  render() {
    const { cart } = this.state;

    if (!cart) {
      return null;
    }

    return (
      <div className={`${this.props.classes.component} theme-language-bar`}>
        <div className="chk-wrapper">
          <div className="chk-language__logo">
            <SvgIcon name="checkoutLogo" />
            <span>Checkout Sun</span>
          </div>
          <div className="chk-language__selectLanguage">
            <Translate term="Selecionar País:" />
            <ConfigCountry hideCurrency={this.hideCurrency()} />
          </div>
        </div>
      </div>
    );
  }
}
